module.exports = __webpack_public_path__ + "static/media/ashmore-ellis-loop-1.3e5b6742.mp4";